import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import { MuiThemeProvider as MaterialUIThemeProvider } from "@material-ui/core/styles";

import { tooltipSizes, alignments } from "core/props";

import ClickToOpen from "./ClickToOpen";
import HoverToOpen from "./HoverToOpen";
import Title from "./Title";

import { TooltipContainer, tooltipThemeStyles } from "./styles";

import { MuiThemeProvider } from "js/helpers/materialUI";

const UnstyledTooltip = ({
    darkMode = false,
    size = "large",
    clickToOpen = false,
    interactive = true,
    textAlignment,
    message,
    zIndex = 99999,
    children,
    className,
    placement = "bottom"
}) => {
    // set flag:
    const isSmallTooltip = size === "small";

    // reusable component props to keep it DRY:
    const reusableTooltipProps = {
        arrow: true,
        interactive: interactive,
        darkMode: darkMode,
        isSmallTooltip: isSmallTooltip,
        textAlignment: textAlignment,
        message: message,
        placement: placement,
        title: (
            <Title
                textAlignment={textAlignment}
                darkMode={darkMode}
                message={message}
                isSmallTooltip={isSmallTooltip}
            />
        )
    };

    // the versions of components:
    const components = {
        click: ClickToOpen,
        hover: HoverToOpen
    };

    // conditionally render the component we're using for the return statement:
    const ComponentName = clickToOpen ? components.click : components.hover;

    return (
        <MuiThemeProvider>
            <MaterialUIThemeProvider
                theme={tooltipThemeStyles({ darkMode, isSmallTooltip, zIndex })}
            >
                <TooltipContainer className={className}>
                    <ComponentName
                        className={className}
                        {...reusableTooltipProps}
                    >
                        {children}
                    </ComponentName>
                </TooltipContainer>
            </MaterialUIThemeProvider>
        </MuiThemeProvider>
    );
};

const Tooltip = styled(UnstyledTooltip)``;

Tooltip.propTypes = {
    message: PropTypes.oneOfType([PropTypes.string, PropTypes.element])
        .isRequired,
    children: PropTypes.any.isRequired,
    size: PropTypes.oneOf(tooltipSizes),
    darkMode: PropTypes.bool,
    textAlignment: PropTypes.oneOf(alignments),
    interactive: PropTypes.bool,
    clickToOpen: PropTypes.bool,
    zIndex: PropTypes.number
};

export default Tooltip;
